import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchAccounts } from 'api/account';
import { useAppState } from 'customHooks/useAppState';
import { accountQueryKeys } from 'queries/account-query-keys';

const useFetchAccounts = () => {
    const apiUrl = useAppState(state => state.apiUrl);
    return useSuspenseQuery({
        queryKey: accountQueryKeys.all(),
        queryFn: fetchAccounts,
        select: data => {
            if (data.length === 0) {
                window.location.href = `${apiUrl}/profile`;
            }

            return data;
        },
        staleTime: Infinity,
        retry: false,
    });
};

export { useFetchAccounts };
